<template>
  <div v-if="jobHistoryData.length" class="job-detail-history">
    <div class="job-detail-history-list">
      <preloader :value="load"></preloader>

      <job-history-item
        v-for="item in jobHistoryData"
        :key="item.ID"
        :history="item"
        :accountTypes="accountTypes"
      ></job-history-item>
    </div>

    <div v-if="jobHistoryData.length" class="job-history-pagination">
      <pagination
        v-model="query"
        :options="[5,10,20,50]"
        all
        :total="total"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import jobHistoryItem from './jobHistoryItem/index.vue';
import pagination from '@/components/paginationSimple/index.vue';
import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

export default Vue.extend({
  props: {
    accountTypes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    jobHistoryItem,
    pagination,
    preloader,
  },
  data() {
    return {
      jobHistoryData: [],

      query: {
        page: 1,
        ppage: 10,
      },

      load: false,
      total: 0,
    };
  },
  watch: {
    query: {
      deep: true,
      handler () {
        this.getJobHistory();
      },
    },
  },
  created() {
    this.getJobHistory();
  },
  methods: {
    getJobHistory() {
      this.total = 0;
      this.load = true;

      const params = {
        jobid: this.$route.params.id,
        ...this.query,
      };

      Api.jobs.getHistory(params).then((response) => {
        if (response.data.Status) {
          this.jobHistoryData = response.data.Data;
          this.total = response.data.Total;
          this.load = false;
        }
      });
    },
  },
});
</script>

<style lang="scss">
.job-detail-history {

    &-list {
        position: relative;
    }

    &-row {
        background-color: $color-white;
        margin-bottom: 1px;
    }

    &-block {
        @include flex (row, space-between, center);
    }

    &-data {
        @include flex (row, space-between, center);
        padding: 13px 17px;
        flex-basis: 70%;

        &-profile {
            @include flex (row, flex-start, center);
            flex-wrap: wrap;
            flex-basis: 30%;
            color: $color-blue;
            p {
                font-weight: 500;
            }
        }
        &-text {
            flex-basis: 65%
        }
    }

    &-when,
    &-status {
        @include flex (row, center, center);
        flex-basis: 20%;
    }
}
</style>
